import { SocialFacebookIcon } from 'foundations-assets/icons/components/SocialFacebookIcon';
import { SocialGoogleIcon } from 'foundations-assets/icons/components/SocialGoogleIcon';
import { SocialGoogleDriveIcon } from 'foundations-assets/icons/components/SocialGoogleDriveIcon';
import { SocialGoogleplusIcon } from 'foundations-assets/icons/components/SocialGoogleplusIcon';
import { SocialHeartIcon } from 'foundations-assets/icons/components/SocialHeartIcon';
import { SocialInstagramIcon } from 'foundations-assets/icons/components/SocialInstagramIcon';
import { SocialLinkedinIcon } from 'foundations-assets/icons/components/SocialLinkedinIcon';
import { SocialPinterestIcon } from 'foundations-assets/icons/components/SocialPinterestIcon';
import { SocialRetweetIcon } from 'foundations-assets/icons/components/SocialRetweetIcon';
import { SocialRssIcon } from 'foundations-assets/icons/components/SocialRssIcon';
import { SocialSlackIcon } from 'foundations-assets/icons/components/SocialSlackIcon';
import { SocialTwitterIcon } from 'foundations-assets/icons/components/SocialTwitterIcon';
import { SocialXIcon } from 'foundations-assets/icons/components/SocialXIcon';
import { SocialXingIcon } from 'foundations-assets/icons/components/SocialXingIcon';
import { SocialYoutubeIcon } from 'foundations-assets/icons/components/SocialYoutubeIcon';
import { SocialYoutubeplayIcon } from 'foundations-assets/icons/components/SocialYoutubeplayIcon';
export const SOCIAL_MAP = {
  facebook: {
    icon: SocialFacebookIcon,
    color: 'do-not-use-facebook'
  },
  google: {
    icon: SocialGoogleIcon,
    color: 'do-not-use-google'
  },
  googledrive: {
    icon: SocialGoogleDriveIcon,
    color: 'do-not-use-google'
  },
  googleplus: {
    icon: SocialGoogleplusIcon,
    color: 'do-not-use-google'
  },
  heart: {
    icon: SocialHeartIcon,
    color: 'do-not-use-candy-apple'
  },
  instagram: {
    icon: SocialInstagramIcon,
    color: 'do-not-use-instagram'
  },
  linkedin: {
    icon: SocialLinkedinIcon,
    color: 'do-not-use-linkedin'
  },
  pinterest: {
    icon: SocialPinterestIcon,
    color: 'do-not-use-pinterest'
  },
  retweet: {
    icon: SocialRetweetIcon,
    color: 'do-not-use-twitter'
  },
  rss: {
    icon: SocialRssIcon,
    color: 'do-not-use-rss'
  },
  slack: {
    icon: SocialSlackIcon,
    color: 'do-not-use-facebook'
  },
  twitter: {
    icon: SocialTwitterIcon,
    color: 'do-not-use-twitter'
  },
  x: {
    icon: SocialXIcon,
    color: 'do-not-use-x'
  },
  xing: {
    icon: SocialXingIcon,
    color: 'do-not-use-xing'
  },
  youtube: {
    icon: SocialYoutubeIcon,
    color: 'do-not-use-youtube'
  },
  youtubeplay: {
    icon: SocialYoutubeplayIcon,
    color: 'do-not-use-youtube'
  }
};
export const AVATAR_SIZES = {
  xxs: 16,
  xs: 24,
  sm: 32,
  md: 48,
  lg: 72,
  xl: 108,
  responsive: 'responsive'
};
export const AVATAR_LIST_SIZES_MARGIN_OFFSET = {
  xxs: '-50',
  xs: '-100',
  sm: '-100',
  md: '-200',
  lg: '-200',
  xl: '-400',
  responsive: '0'
};
export const DEFAULT_AVATAR_TYPES = {
  AI_AGENT: 'AI_AGENT',
  CONTACT: 'CONTACT',
  COMPANIES: 'COMPANIES',
  PRODUCT: 'PRODUCT',
  TICKET: 'TICKET',
  DEAL: 'DEAL'
};
export const AVATAR_TYPES = {
  // AI Agents
  'ai-agent': DEFAULT_AVATAR_TYPES.AI_AGENT,
  // Companies
  company: DEFAULT_AVATAR_TYPES.COMPANIES,
  companyId: DEFAULT_AVATAR_TYPES.COMPANIES,
  domain: DEFAULT_AVATAR_TYPES.COMPANIES,
  enrichmentDomain: DEFAULT_AVATAR_TYPES.COMPANIES,
  // Contacts
  contact: DEFAULT_AVATAR_TYPES.CONTACT,
  email: DEFAULT_AVATAR_TYPES.CONTACT,
  emails: DEFAULT_AVATAR_TYPES.CONTACT,
  enrichmentEmail: DEFAULT_AVATAR_TYPES.CONTACT,
  hubSpotUserEmail: DEFAULT_AVATAR_TYPES.CONTACT,
  hubSpotUserEmails: DEFAULT_AVATAR_TYPES.CONTACT,
  vid: DEFAULT_AVATAR_TYPES.CONTACT,
  // Deals
  deal: DEFAULT_AVATAR_TYPES.DEAL,
  // Products
  productId: DEFAULT_AVATAR_TYPES.PRODUCT,
  // Tickets
  ticket: DEFAULT_AVATAR_TYPES.TICKET
};
export const AVATAR_TYPE_ICONS = {
  COMPANIES: 'companies',
  CONTACT: 'contacts',
  PRODUCT: 'product',
  TICKET: 'ticket',
  DEAL: 'deals'
};
export const RETINA_MULTIPLIER = 2;
export const API_KNOWN_KEY_MAPPINGS = {
  contact: 'knownContacts',
  company: 'knownCompanies'
};
export const API_KNOWN_VALUE_MAPPINGS = {
  contact: {
    primaryIdentifier: 'vid',
    secondaryIdentifier: 'email'
  },
  company: {
    primaryIdentifier: 'companyId',
    secondaryIdentifier: 'domain'
  }
};
export const API_IDENTIFIER_MAPPINGS = {
  // vids
  contact: 'vids',
  vids: 'vids',
  vid: 'vids',
  // companyIds
  company: 'companyIds',
  companyId: 'companyIds',
  // emails
  email: 'emails',
  enrichmentEmail: 'emails',
  // domains
  domain: 'domains',
  enrichmentDomain: 'domains',
  // hubSpotUserEmails
  'ai-agent': 'hubSpotUserEmails',
  hubSpotUserEmails: 'hubSpotUserEmails',
  hubSpotUserEmail: 'hubSpotUserEmails',
  // productIds
  product: 'productIds',
  productId: 'productIds'
};
export const DEFAULT_MAX_UPLOAD_SIZE_MB = 4;
export const OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = {
  contact: 'contacts/vid',
  vid: 'contacts/vid',
  company: 'companies/companyId',
  companyId: 'companies/companyId',
  product: 'products/productId',
  productId: 'products/productId'
};
export const OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = ['contact', 'vid', 'company', 'companyId', 'product', 'productId'];
export const AVATAR_SOURCE_TYPES = {
  DEFAULT_COMPANY_AVATAR: 'default-company-avatar',
  DEFAULT_CONTACT_AVATAR: 'default-contact-avatar',
  KNOWN_SRC: 'known-src'
};
export const MULTI_AVATAR_DEFAULT_BORDER_COLOR = 'border-core-on-fill-default';
export const MULTI_AVATAR_DEFAULT_BORDER_WIDTH = '200';
export const MULTI_AVATAR_DEFAULT_BORDER_STYLE = 'solid';
export const AVATAR_BACKGROUND_COLOR_THEME_KEY = 'fill-accent-neutral-default';
export const AVATAR_ICON_COLOR_THEME_KEY = 'icon-primary-default';
export const DEFAULT_PROPS = {
  showTooltip: true,
  size: 'sm',
  childMarginInlineStart: '300',
  childTruncateLength: 200
};